import * as actions from './actions';

const userModule = {
  namespaced: true,
  actions,
};

export default userModule;
